export function OnboardingChip({ label, selected = false, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={selected}
      className={[
        "rounded-xl border px-4 py-2.5 text-sm font-medium transition",
        selected
          ? "border-[#f19500] bg-[#fff9ee] text-[#9A3412]"
          : "border-[#d4c4b0] bg-[#faf8f5] text-[#374151] hover:border-[#c4b5a0]",
      ].join(" ")}
    >
      {label}
    </button>
  );
}
